<template>
    <v-app>
        <v-content>
            <router-view/>
        </v-content>
    </v-app>
</template>

<script>
    export default {
        name: 'VuebaseLayout',
        data() {
            return {
                appName: process.env.VUE_APP_NAME,
            }
        },
    }
</script>